import { Button } from "@mantine/core";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";

const PayNow = ({ salesOrder, payment, setSalesOrder,setSaveTransaction,saveTransaction, customerId, acceptPayment, approveAdvance, acceptPayment1, paymentClose }) => {


  const totalAmount = salesOrder?.payment?.amountNeedToBePaid || 0;
  const formattedTotal = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(totalAmount);
console.log(salesOrder,"ijdddd")
//   useEffect(() => {
//   if (!salesOrder?.paymentHistory?.paymentDate) {
//     setSalesOrder((prev) => ({
//       ...prev,
//       paymentHistory: {
//         ...prev.paymentHistory,
//         paymentDate: moment().format("YYYY-MM-DD"),
//       },
//     }));
//   }
// }, [salesOrder]);
  const requiredFields =
    salesOrder?.paymentHistory?.modeOfPayment === "bankTransfer"
      ? ["accountNo", "ifscCode", "bankName", "utrNo", "paymentDate"]
      : salesOrder?.paymentHistory?.modeOfPayment === "creditcard"
        ? [
          "creditCardNumber",
          "creditCardHolderName",
          "creditCardExpiryDate",
          "creditCardCVV",
          "creditCardBrand",
          "paymentDate",
        ]
        : [];

  const allFieldsFilled = requiredFields.every(
    (field) =>
      salesOrder?.paymentHistory?.[field] !== undefined &&
      salesOrder?.paymentHistory?.[field] !== null &&
      salesOrder?.paymentHistory?.[field]?.toString().trim() !== ""
  );


  const paymentDetails = [
    {
      header: "Payment Mode",
      type: "Select",
      label: "Mode Of Payment",
      name: "modeOfPayment",
      accessorKey: "modeOfPayment",
      placeholder: "Select mode of payment",
      value: salesOrder?.paymentHistory?.modeOfPayment || "",
      onChange: (e) =>
        handlePaymentFieldChange(e, { name: "modeOfPayment", type: "Select" }),
      options: [
        ...(salesOrder?.orderType !== "WHOLESALE"
          ? [{ label: "Razor Pay", value: "creditcard" }]
          : []),
        { label: "Bank Transfer", value: "bankTransfer" },
      ],
    },
  ];

  const creditCardFields = useMemo(() => [
    {
      header: "Credit Card Number",
      type: "TextInput",
      label: "Card Number",
      name: "creditCardNumber",
      accessorKey: "creditCardNumber",
      placeholder: "Enter card number",
      value: salesOrder?.paymentHistory?.creditCardNumber || "",
      onChange: (e) => {
        let value = e.target.value;

        const numericValue = value.replace(/\D/g, "");
        const limitedValue = numericValue.slice(0, 16);

        handlePaymentFieldChange(
          { target: { name: "creditCardNumber", value: limitedValue } },
          { name: "creditCardNumber", type: "TextInput" }
        );
      },


    },
    {
      header: "Card Holder Name",
      type: "TextInput",
      label: "Card Holder Name",
      name: "creditCardHolderName",
      accessorKey: "creditCardHolderName",
      placeholder: "Enter holder name",
      value: salesOrder?.paymentHistory?.creditCardHolderName || "",
      onChange: (e) =>
        handlePaymentFieldChange(e, {
          name: "creditCardHolderName",
          type: "TextInput",
        }),
    },
    {
      header: "Card Expiry Date",
      type: "Date",
      label: "Card Expiry Date",
      name: "creditCardExpiryDate",
      accessorKey: "creditCardExpiryDate",
      placeholder: "Select expiry date",
      value: salesOrder?.paymentHistory?.creditCardExpiryDate
        ? moment(salesOrder.paymentHistory.creditCardExpiryDate).format(
          "YYYY-MM-DD"
        )
        : "",
      onChange: (value) =>
        handlePaymentFieldChange(value, {
          name: "creditCardExpiryDate",
          type: "Date",
        }),
    },
    {
      header: "CVV",
      type: "TextInput",
      label: "CVV",
      name: "creditCardCVV",
      accessorKey: "creditCardCVV",
      placeholder: "Enter CVV",
      value: salesOrder?.paymentHistory?.creditCardCVV || "",
      onChange: (e) => {
        let value = e.target.value;

        const numericValue = value.replace(/\D/g, "");
        const limitedValue = numericValue.slice(0, 3);

        handlePaymentFieldChange(
          { target: { name: "creditCardCVV", value: limitedValue } },
          { name: "creditCardCVV", type: "TextInput" }
        );
      },
    },
    {
      header: "Deposit Amount",
      type: "TextInput",
      label: "Deposit Amount",
      name: "depositAmount",
      placeholder: "",
      value: payment?.PayAmount || 0,
      readOnly: true,
    },
    {
      header: "Card Brand",
      type: "TextInput",
      label: "Card Brand",
      name: "creditCardBrand",
      accessorKey: "creditCardBrand",
      placeholder: "Enter card brand",
      value: salesOrder?.paymentHistory?.creditCardBrand || "",
      onChange: (e) =>
        handlePaymentFieldChange(e, {
          name: "creditCardBrand",
          type: "TextInput",
        }),
    },
    {
      header: "Deposit Date",
      type: "Date",
      label: "Deposit Date",
      name: "paymentDate",
      accessorKey: "paymentDate",
      placeholder: "Select deposit date",
      value: salesOrder?.paymentHistory?.paymentDate
        ? moment(salesOrder.paymentHistory.paymentDate).format("YYYY-MM-DD")
        : "",
      onChange: (value) =>
        handlePaymentFieldChange(value, { name: "paymentDate", type: "Date" }),
      max: moment().format("YYYY-MM-DD"),
    },
  ], [salesOrder]);

  const bankTransferFields = useMemo(() => [
    {
      header: "Account Number",
      type: "TextInput",
      label: "Account Number",
      name: "accountNo",
      accessorKey: "accountNo",
      placeholder: "Enter account number",
      value: salesOrder?.paymentHistory?.accountNo || "",
      onChange: (e) =>
        handlePaymentFieldChange(e, { name: "accountNo", type: "TextInput" }),
    },
     {
      header: "Confirm Account Number",
      type: "TextInput",
      label: "Confirm Account Number",
      name: "confirmAccountNo",
      accessorKey: "confirmAccountNo",
      placeholder: "Enter Confirm account number",
      value: salesOrder?.paymentHistory?.confirmAccountNo || "",
      onChange: (e) =>
        handlePaymentFieldChange(e, { name: "confirmAccountNo", type: "TextInput" }),
    },
    {
      header: "IFSC Code",
      type: "TextInput",
      label: "IFSC Code",
      name: "ifscCode",
      accessorKey: "ifscCode",
      placeholder: "Enter IFSC code",
      value: salesOrder?.paymentHistory?.ifscCode || "",
      onChange: (e) =>
        handlePaymentFieldChange(e, { name: "ifscCode", type: "TextInput" }),
    },
    {
      header: "Bank Name",
      type: "TextInput",
      label: "Bank Name",
      name: "bankName",
      accessorKey: "bankName",
      placeholder: "Enter bank name",
      value: salesOrder?.paymentHistory?.bankName || "",
      onChange: (e) =>
        handlePaymentFieldChange(e, { name: "bankName", type: "TextInput" }),
    },
    {
      header: "UTR Number",
      type: "TextInput",
      label: "UTR Number",
      name: "utrNo",
      accessorKey: "utrNo",
      placeholder: "Enter UTR number",
      value: salesOrder?.paymentHistory?.utrNo || "",
      onChange: (e) =>
        handlePaymentFieldChange(e, { name: "utrNo", type: "TextInput" }),
    },
        {
      header: "Order Amount",
      type: "TextInput",
      label: "Total Order Amount",
      name: "totalAmount",
      accessorKey: "totalAmount",
      placeholder: "",
      value: salesOrder?.payment?.totalAmount || 0,
      readOnly: true,
    },
    {
      header: "Payment % of Order Amt",
      type: "TextInput",
      label: "Payment % of Order Amt",
      name: "actualOrderStockpercentage",
      accessorKey: "actualOrderStockpercentage",
      placeholder: "",
      value: salesOrder?.payment?.actualOrderStockpercentage || 0,
      readOnly: true,
    },
    // {
    //   header: "Actual Amount",
    //   type: "TextInput",
    //   label: "Actual Amount",
    //   name: "actualAmount",
    //   accessorKey: "actualAmount",
    //   placeholder: "",
    //   value: (() => {
    //     const total = salesOrder?.payment?.totalAmount || 0;
    //     const percent = salesOrder?.payment?.actualOrderStockpercentage || 0;

    //     return Math.round((total * percent) / 100);
    //   })(),
    //   readOnly: true,
    // },
    {
      header: "Deposit Amount",
      type: "TextInput",
      label: "Minimum Payable Amount",
      name: "depositAmount",
      accessorKey: "depositAmount",
      placeholder: "",
      value: salesOrder?.payment?.PayAmount || salesOrder?.payment?.amountNeedToBePaid,
      readOnly: true,
    },
     ...(salesOrder?.orderType === "WHOLESALE"
    ? [
        {
      type: "TextInput",
      label: "Actual Payment",
      name: "possibleAmount",
      accessorKey: "possibleAmount",
      placeholder: "Enter possible amount",
      note: "Actual Payment Amt Should Be More Than The Minimum Payable Amt",
      onChange: (e) => {
        const value = Number(e.target.value);
        const maxAmount = Number(salesOrder?.payment?.amountNeedToBePaid || 0);
        setSalesOrder((prev) => ({
          ...prev,
          payment: {
            ...prev.payment,
            possibleAmount: e.target.value,
          },
        }));
      }
       },
      ]
    : []),
    {
      header: "Deposit Date",
      type: "Date",
      label: "Deposit Date",
      name: "paymentDate",
      accessorKey: "paymentDate",
      placeholder: "Select deposit date",
      value: salesOrder?.paymentHistory?.paymentDate
        ? moment(salesOrder.paymentHistory.paymentDate).format("YYYY-MM-DD")
        : "",
      onChange: (value) =>
        handlePaymentFieldChange(value, { name: "paymentDate", type: "Date" }),
    },
  ], [salesOrder, payment]);

  const modeFieldMap = {
    // creditcard: creditCardFields,
    bankTransfer: bankTransferFields,
  };

  const handlePaymentChange = (eOrValue, index, field) => {
    if (field?.type === "DateInput") {
      const name = field.name;
      const value = eOrValue; // direct value from DateInput
      setSalesOrder((prev) => ({
        ...prev,
        paymentHistory: {
          ...prev.paymentHistory,
          [name]: moment(value).format("YYYY-MM-DD"),
        },
      }));
    } else {
      const { name, value } = eOrValue.target;
      if (name === "possibleAmount") {
        setSalesOrder((prev) => ({
          ...prev,
          payment: {
            ...prev.payment,
            [name]: value,
          },
        }));
      }
      if (value === 'creditcard') {
        acceptPayment(salesOrder)
        // acceptPayment({
        //   orderNo: orderItem?.referenceNo,
        //   receiptNo: orderItem?.adjustmentType === "DC" ? orderItem?.referenceNo : null

        // })
      } else {

        setSalesOrder((prev) => ({
          ...prev,
          paymentHistory: {
            ...prev.paymentHistory,
            [name]: value,
          },
        }));
      }
    }
  };


  const handlePaymentFieldChange = (e, field) => {
    const { name, value } = e.target;

    if (name === 'possibleAmount') {
      setSalesOrder((prev) => ({
        ...prev,
        payment: {
          ...prev.payment,
          [name]: value,
        },
      }));
    }
        if (name === 'confirmAccountNo') {
      setSalesOrder((prev) => ({
        ...prev,
        payment: {
          ...prev.payment,
          [name]: value,
        },
      }));
    }
    setSalesOrder((prev) => ({
      ...prev,
      paymentHistory: {
        ...prev.paymentHistory,
        [name]: value,
      },
    }));
  };

  return (
    <div>
      {paymentDetails
        .filter((field) => field.type === "Select")
        .map((field, index) => (
          <div key={index} style={{ marginBottom: "1rem" }}>
            <label style={{ display: "block", marginBottom: "0.5rem" }}>
              {field.label}
            </label>

            <select
              name={field.name}
              value={field.value}
              onChange={(e) => {
                field.onChange?.(e);
                handlePaymentChange(e, index, field);
              }}
              style={{
                width: "100%",
                padding: "0.5rem",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
            >
              <option value="" disabled>
                {field.placeholder}
              </option>

              {field.options?.map((option, optionIndex) => (
                <option key={optionIndex} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        ))}

      {modeFieldMap[salesOrder?.paymentHistory?.modeOfPayment]?.map(
        (field, index) => (
          <div key={`mode-${index}`} style={{ marginBottom: "1rem" }}>
            <label style={{ display: "block", marginBottom: "0.5rem" }}>
              {field.label}
            </label>

            {field.type === "Select" ? (
              <select
                name={field.name}
                value={field.value}
                onChange={(e) => handlePaymentChange(e, index)}
                style={{
                  width: "100%",
                  padding: "0.5rem",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                }}
              >
                <option value="" disabled>
                  {field.placeholder}
                </option>
                {field.options?.map((option, optionIndex) => (
                  <option key={optionIndex} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            ) : field.type === "Date" ? (
              <input
                type="date"
                name={field.name}
                value={field.value}
                onChange={(e) => handlePaymentChange(e, index)}
                max={moment().format("YYYY-MM-DD")}
                style={{
                  width: "100%",
                  padding: "0.5rem",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                }}
              />
            ) : field.type === "TextInput" ? (<>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  width: "100%",
                }}
              >
                <input
                  type="text"
                  name={field.name}
                  value={field.value}
                  onChange={(e) => handlePaymentChange(e, index, field)}
                  style={{
                    flex: 1,
                    padding: "0.5rem",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                />

                {field.name === "possibleAmount" && (
                  <Button
                    color="green"
                    size="sm"
                    onClick={() => approveAdvance(salesOrder?.payment)}
                    disabled={!salesOrder?.payment?.possibleAmount || (Number(salesOrder?.payment?.possibleAmount) === salesOrder?.payment?.amountNeedToBePaid) ||  (Number(salesOrder?.payment?.possibleAmount) < salesOrder?.payment?.amountNeedToBePaid) ||  (Number(salesOrder?.payment?.possibleAmount) > salesOrder?.payment?.totalAmount)}
                  >
                    Proceed
                  </Button>
                )}
              </div>
              {field.note && (
                <div style={{ fontSize: "10px ", color: "red", fontWeight: "bold" }}>
                  Note : <span style={{ color: "gray" }}>{field.note}</span>
                </div>
              )}</>
            )

              : (
                <input
                  type="number"
                  name={field.name}
                  value={field.value}
                  placeholder={field.placeholder}
                  readOnly={field.readOnly}
                  onChange={(e) => handlePaymentChange(e, index)}
                  style={{
                    width: "100%",
                    padding: "0.5rem",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                />
              )}
          </div>
        )
      )}
 {modeFieldMap[salesOrder?.paymentHistory?.modeOfPayment] &&
<div style={{display:"flex",flexDirection:"row"}}>
  <label style={{display:"flex",flexDirection:"row",gap:"5px"}}>
    <input
      type="checkbox"
      style={{ accentColor: "#8BC53F" }}
      checked={saveTransaction}
      onChange={(e) => setSaveTransaction(e.target.checked)}
    />
    Save transaction details for future use
  </label>
</div>}
      {modeFieldMap[salesOrder?.paymentHistory?.modeOfPayment] && <div
        style={{
          marginTop: "1rem",
          display: "flex",
          gap: "1rem",
          justifyContent: "center",
        }}
      >
        <Button color="red" onClick={paymentClose}>
          Cancel
        </Button>
        <Button
          onClick={acceptPayment1}
          style={{
            backgroundColor:
              allFieldsFilled && !salesOrder?.payment?.possibleAmount
                ? "#8BC53F"
                : "#ccc",
            cursor:
              allFieldsFilled && !salesOrder?.payment?.possibleAmount
                ? "pointer"
                : "not-allowed",
          }}
          disabled={!(allFieldsFilled && !salesOrder?.payment?.possibleAmount)}
        >
          Pay ₹ {salesOrder?.payment?.amountNeedToBePaid}
        </Button>


      </div>}
    </div>
  );
};


export default PayNow;
